import {gql} from '@apollo/client';
export const customerSubscriptionInfoBoxesFragment = gql`
  fragment CustomerSubscriptionInfoBoxesFragment on Subscription {
    id
    hasMembership
    paymentMethodId
    discounts {
      title
      amount
      type
      category
      productVariantId
    }
  }
`;

export const profileInfoBoxesQuery = gql`
  ${customerSubscriptionInfoBoxesFragment}
  query ProfileInfoBoxQuery {
    me {
      id
      userProfile {
        id
        firstName
        lastName
        email
      }
      customerAccount {
        id
        subscription {
          ...CustomerSubscriptionInfoBoxesFragment
        }
        shippingAddress {
          address
          city
          addressDetail
          postalCode
          provinceCode
          province
          countryCode
          country
          firstName
          lastName
        }
        paymentMethods {
          id
          expiryMonth
          expiryYear
          lastDigits
          brand
          type
        }
      }
    }
  }
`;
